import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { ApiOnlyLabel } from '../../../components/api-only-label'

function AngularApiOnlyLabel(props) {
  return <ApiOnlyLabel {...props} />
}

export const reactApiOnlyLabel = createNgReactBridgeDirective(
  'reactApiOnlyLabel',
  [],
  AngularApiOnlyLabel,
  ['serviceKey', 'onCopyServiceKey', 'role']
)
